export const TEL_LINK = "tel:+31970065347";
export const PHONE_DISPLAY = "+31 970 065 347";
export const WHATSAPP_URL =
  "https://wa.me/31628269127?text=Hoi%2C%20ik%20wil%20graag%20meer%20weten%20over%204thscenery";
export const WHATSAPP_DISPLAY = "+31 6 2826 9127";
export const EMAIL_DISPLAY = "F4thscenery@outlook.com";
export const CAL_LINK = "joey-tyrone-fol6zh/15min";
export const MM_PHOTO =
  "https://customer-assets-v7afamib.emergentagent.net/job_978f48c2-972c-405b-a7ad-15e44b9c560b/artifacts/grtl8pzi_image.png";
export const MM_LOGO =
  "https://customer-assets-v7afamib.emergentagent.net/job_978f48c2-972c-405b-a7ad-15e44b9c560b/artifacts/h141ra40_image.png";
export const HERO_IMG =
  "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?q=80&w=1600&auto=format&fit=crop";
export const ABOUT_IMG =
  "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1600&auto=format&fit=crop";
export const BOOK_IMG =
  "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1600&auto=format&fit=crop";
export const HERO_VIDEO = "/hero-showreel.mp4";
export const MM_BG =
  "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?q=80&w=2000&auto=format&fit=crop";
export const VV_BG =
  "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=2000&auto=format&fit=crop";
export const MM_VIDEO =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_scenery-studio/artifacts/ucrte2hk_Dit%20is%20geen%20standaard%20reis%2C%20dit%20is%20de%20litest%20community-movement%20in%20jaren.%20Vergeet%20je%20comfortzone.mp4";
